module.exports = __webpack_public_path__ + "static/media/tactical.fe7f85e7.png";